import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ar from '../locales/ar'
import en from '../locales/en'
import ku from '../locales/ku'
Vue.use(VueI18n)
export const i18n=new VueI18n({
    locale:'en',
    fallbackLocale:'en',
    messages:{
       en,ar,ku
    }
})